import eventMatchesToolNames from './eventMatchesToolNames';
import type { EventMatchesPlaybookLifecycleToolParams } from '../types';

const PLAYBOOK_LIFECYCLE_TOOL_NAMES = [
    'create_playbook',
    'admin.playbooks.create',
    'update_playbook',
    'admin.playbooks.update',
    'create_playbook_draft',
    'admin.playbooks.createDraft',
    'publish_playbook_version',
    'admin.playbooks.publish',
];

const eventMatchesPlaybookLifecycleTool = ({
    event,
}: EventMatchesPlaybookLifecycleToolParams): boolean =>
    eventMatchesToolNames({ event, toolNames: PLAYBOOK_LIFECYCLE_TOOL_NAMES });

export default eventMatchesPlaybookLifecycleTool;
